interface RouteService {
    [key: string]: string; // This allows dynamic property access
    HOME: string;
    CAREERS: string;
    OPENPOSITIONS: string;
    JOP: string;
    USER_FORM: string;
    NOT_FOUND: string;
    THANK_YOU: string;
    PRIVACY_POLICY: string;

}

export const routeService: RouteService = {
    HOME: '/',
    CAREERS: '/careers',
    OPENPOSITIONS: '/open-positions',
    JOP: '/job',
    USER_FORM: '/apply-form',
    NOT_FOUND: '/notFound',
    THANK_YOU: '/thank-you',
    PRIVACY_POLICY: '/privacy-policy',

}


